import { useState, useEffect } from 'react';
import {
  Container, Col, Anchor,
} from 'react-bootstrap';
import { chunk } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StateRedux } from '../../store/type-redux';
import {
  AlertReact, CardProduto, load, Scroll,
} from '../../components';
import { api, doRefreshToken, tools } from '../../utils';
import { Aplicacao } from '../../@types/exports';

const HtmlLink = ({ texto, link }: any) => {
  const { t } = useTranslation();

  return (
    <div>
      <span>
        {t(`home.${texto}`)}
      </span>
      <Anchor
        href={link}
        style={{ color: '#999', textDecoration: 'none' }}
        onClick={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('@[REDUX-MTRIX-LOGIN]');
        }}
      >
        <Col>
          {texto}
        </Col>
      </Anchor>
    </div>
  );
};

const Home = () => {
  doRefreshToken.getRefreshToken();
  const {
    aplicacoes,
    favorite: { ids },
    keycloak,
    language: { languageSelected },
  } = useSelector((state: StateRedux) => state);

  const [applications, setApplications] = useState<Aplicacao[] | undefined | null>(aplicacoes);

  const { t } = useTranslation();

  const allOrFavorite = (toggle: string) => {
    if (toggle === 'all') {
      setApplications(aplicacoes);
    }

    if (toggle === 'favorite') {
      setApplications(
        aplicacoes
          ?.filter((aplicacao) => ids.find((id) => aplicacao.id === id)),
      );
    }
  };

  const buscaUrlComHash = async (url: string | null) => {
    try {
      if (keycloak) {
        keycloak.updateToken(3601)
          .success(async () => {
            const { token, refreshToken } = keycloak;
            const { data: webTicket } = await api.getWebTicket();
            if (url?.includes('authenticate.aspx')) {
              const urlFinal = url + webTicket;
              window.open(`${urlFinal}`, '_blank');
            } else if (url?.includes('&u=')) {
              window.open(`${url}`, '_blank');
            } else {
              window.open(`${url}?token=${token}&refreshtoken=${refreshToken}`, '_blank');
            }
          });

        return;
      }

      const refreshTokenLocal = localStorage.getItem('refreshToken');

      load.show();

      const {
        data: {
          token,
          refresh_token: refreshToken,
        },
      } = await api.refreshToken(refreshTokenLocal);

      if (url?.includes('authenticate.aspx')) {
        const { data: webTicket } = await api.getWebTicket();
        const urlFinal = url + webTicket;
        window.open(`${urlFinal}`, '_blank');
      } else if (url?.includes('&u=')) {
        window.open(`${url}`, '_blank');
      } else {
        window.open(`${url}?token=${token}&refreshtoken=${refreshToken}`, '_blank');
      }
    } catch {
      AlertReact.message({
        html: <HtmlLink texto="Not found" />,
        confirmButtonColor: '#2e59d9',
      });
    } finally {
      load.hide();
    }
  };

  const justifyAround = (index: number, pedaco: Aplicacao[]) => (
    index === 0 && pedaco.length > 1 ? 'd-flex justify-content-around' : ''
  );

  useEffect(() => {
    setApplications(aplicacoes);
  }, [aplicacoes]);

  return (
    <Container fluid>
      <div style={{ height: '80vh' }}>
        {aplicacoes?.length && (
          <div className="d-flex justify-content-between align-items-sm-center flex-column flex-sm-row mb-4">
            <div className="me-4 mb-3 mb-sm-0">
              <div className="small mt-3">
                <Anchor
                  className="btn text-primary ml-1 font-size-20"
                  onClick={() => allOrFavorite('favorite')}
                >
                  {t('home.favoritos')}
                </Anchor>
                <Anchor
                  className="btn text-primary ml-4 font-size-20"
                  onClick={() => allOrFavorite('all')}
                >
                  {t('home.todos')}
                </Anchor>
                {/* <Link to="/" className="btn text-primary ml-4 font-size-20">
                  {t('home.conheca')}
                </Link> */}
              </div>
            </div>

          </div>
        )}

        {applications?.length ? (
          <Scroll
            className="card-produto-scroll"
            style={{ paddingBottom: 22, height: '89%' }}
          >
            <div className="card-deck" style={{ margin: 0 }}>
              {chunk(applications, 4).map((pedaco, index) => (
                <div
                  key={tools.geraStringAleatoria(6)}
                  className={`row col-xl-12 col-md-12 mt-3 ${justifyAround(index, pedaco)}`}
                >
                  {pedaco.map((aplicacao) => (
                    <CardProduto
                      key={aplicacao.id}
                      id={aplicacao.id}
                      title={aplicacao.nome}
                      text={aplicacao.descricao[languageSelected]}
                      handleClick={() => buscaUrlComHash(aplicacao.url)}
                    />
                  ))}
                </div>
              ))}
            </div>
          </Scroll>
        ) : (
          <div className="table table-striped alert alert-warning" role="alert">
            <span>{t('home.nenhumEncontrado')}</span>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Home;
